import { useState } from 'react'

import Tab from '@/components/view/atoms/tab/Tab'
import TabList from '@/components/view/atoms/tab/TabList'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import ProductInfoUsageHistorySection from './ProductInfoUsageHistorySection'
import ProductInfoUsageMatrixSection from './ProductInfoUsageMatrixSection'

// 商品情報の利用設定（データ基盤 ＞ 商品情報の利用設定）。
// 検索・レコメンドが読む商品情報を、用途ごとに選ぶ。
// 保存と反映は分かれている（索引はビルド時に焼き込むため、保存だけでは変わらない）。
type PiuTab = 'settings' | 'history'

const ProductInfoUsagePage = () => {
  const [tab, setTab] = useState<PiuTab>('settings')

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title='商品情報の利用設定'
        description='検索・レコメンドが商品マスタのどの情報を使うかを、用途ごとに設定します。設定は保存したあと「反映」して初めて検索結果に効きます。'
      />

      <Content>
        <div className='mt-3'>
          <TabList>
            <Tab selected={tab === 'settings'} onClick={() => setTab('settings')}>
              設定
            </Tab>
            <Tab selected={tab === 'history'} onClick={() => setTab('history')}>
              反映履歴
            </Tab>
          </TabList>
        </div>

        <div>
          {tab === 'settings' ? (
            <ProductInfoUsageMatrixSection />
          ) : (
            <ProductInfoUsageHistorySection />
          )}
        </div>
      </Content>
    </Main>
  )
}

export default ProductInfoUsagePage
